import * as sdk from '@cypro/server/sdk'
import {useQuery} from '@tanstack/react-query'

// How many prescriptions and protocols use a drug; a used drug keeps its dose unit (CY-369)
export function useGetDrugCatalogUsage(drugId: string | undefined) {
  const {data, isLoading} = useQuery({
    queryKey: ['drug-catalog-usage', drugId],
    queryFn: async () => {
      const response = await sdk.getDrugCatalogByIdUsage({path: {id: drugId ?? ''}})
      return response.data
    },
    enabled: Boolean(drugId),
  })

  const prescriptions = data?.prescriptions ?? 0
  const protocols = data?.protocols ?? 0
  return {prescriptions, protocols, isUsed: prescriptions + protocols > 0, isLoading: Boolean(drugId) && isLoading}
}
